import { onApiError } from "../error"
import { state } from "../state"
import { post } from "./client"

/**
 * @param {string} imei 
 * @param {string} name 
 * @returns {Promise<Smartplug>}
 */
async function registerSmartplug(imei, name) {
    const res = await post(`/users/${(await state.getActiveUser()).Id}/smartplugs`, {
        body: JSON.stringify({
            Imei: imei,
            Name: name,
        })
    })

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

export {
    registerSmartplug
}